import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './scripts/AuthManager';
import { BrowserRouter as Router } from "react-router-dom";
import { RegionProvider } from './scripts/RegionManager';
import "./style.css";
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <RegionProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </RegionProvider>
    </Router>
  </React.StrictMode >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
